import NEXT_TRANSFER_TYPE from 'bl/payment/nextTransfertype.const';
import WEEKDAY from 'constants/time/weekday.const';
import addDays from 'utils/date/addDays.util';
import nullBind from 'utils/functions/nullBind.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import parseDate from 'utils/parsers/parseDate';

const L = logger('nextTransferTimestamp');

const nextDay = nullBind(addDays, 1);
const skipOne = nullBind(addDays, 2);
const skipTwo = nullBind(addDays, 3);
const skipThree = nullBind(addDays, 4);

// SEE: https://getslick.atlassian.net/browse/GS-11185
const PAYMENT_MAP = Object.freeze({
  [WEEKDAY.thu]: skipThree,
  [WEEKDAY.fri]: skipThree,
  [WEEKDAY.sat]: skipThree,
  [WEEKDAY.sun]: skipTwo,
  [WEEKDAY.mon]: skipOne,
  [WEEKDAY.tue]: skipOne,
  [WEEKDAY.wed]: nextDay,
});

const REFUND_MAP = Object.freeze({
  [WEEKDAY.fri]: skipTwo,
  [WEEKDAY.sat]: skipOne,
  [WEEKDAY.sun]: nextDay,
  [WEEKDAY.mon]: nextDay,
  [WEEKDAY.tue]: nextDay,
  [WEEKDAY.wed]: nextDay,
  [WEEKDAY.thu]: nextDay,
});

const DEFAULT_SKIP = nextDay;

const nextTransferTimestamp = withOptions(({ date, type }) => {
  // supporting regular integers and strings this way
  const parsed = Number.isFinite(date) ? date : parseDate(date);

  // invalid dates will parse to NaN
  if (Number.isNaN(parsed)) {
    L.warn('()', 'Invalid parsed:', parsed, 'for date:', date);
    return null;
  }

  // NOTE: `.getDay()` is based on the local time zone
  // SEE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
  const day = new Date(parsed).getDay();
  const map = type === NEXT_TRANSFER_TYPE.refund ? REFUND_MAP : PAYMENT_MAP;
  const skip = map[day] || DEFAULT_SKIP;

  return skip(parsed);
});

// noinspection JSUnusedGlobalSymbols
export default nextTransferTimestamp;
